import Vue from 'vue'
import Vuex, { mapGetters } from 'vuex'
import CookieModal from './CookieModal'
import CookieNotice from './CookieNotice'
import CookieSettings from './CookieSettings'
import locale from '../../../vue/locales/localePlugin'
import clientLocaleBundle from '../locales'
import config from '../../../vue/config/configPlugin'
import clientConfigurationBundle from '../config'

Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    SessionCookiesState: {},
    cookieModalVisible: true,
    cookieNoticeVisible: true,
    cookieSettingsVisible: false
  },
  getters: {
    hasAcceptedAdvertisingCookies (state) {
      return state.SessionCookiesState.settings[state.SessionCookiesState.SESS_COOKIE_ADVERTISING]
    }
  },
  mutations: {
    updateCookieSettings: function (state) {
      state.SessionCookiesState.settings[state.SessionCookiesState.SESS_COOKIE_REQUIRED] = document.getElementById('CookiesRequiredCheckbox').checked
      state.SessionCookiesState.settings[state.SessionCookiesState.SESS_COOKIE_ADVERTISING] = document.getElementById('CookiesAdvertisingCheckbox').checked
    },
    updateCookieSettingsAll: function (state) {
      state.SessionCookiesState.settings[state.SessionCookiesState.SESS_COOKIE_REQUIRED] = true
      state.SessionCookiesState.settings[state.SessionCookiesState.SESS_COOKIE_ADVERTISING] = true
    },
    postCookieSettings: function (state) {
      function transformCookieSettings () {
        var settings = state.SessionCookiesState.settings
        settings[state.SessionCookiesState.SESS_COOKIE_REQUIRED] = settings[state.SessionCookiesState.SESS_COOKIE_REQUIRED] ? 1 : 0
        settings[state.SessionCookiesState.SESS_COOKIE_ADVERTISING] = settings[state.SessionCookiesState.SESS_COOKIE_ADVERTISING] ? 1 : 0
        return settings
      }

      document.dispatchEvent(new CustomEvent('cookies-ajax-call', {
        detail: {
          transformCookieSettings: transformCookieSettings()
        }
      }))
    },
    addCookieData: (state, cookies) => {
      state.SessionCookiesState = cookies
    },
    openSettings (state) {
      state.cookieNoticeVisible = false
      state.cookieSettingsVisible = true
    },
    hideModal (state) {
      state.cookieModalVisible = false
    }
  },
  actions: {
    async createCookieSessionState ({ commit }, cookies) {
      commit('addCookieData', cookies)
    },
    async dispatchDMEventIfCookiesAccepted ({ getters }) {
      if (getters.hasAcceptedAdvertisingCookies) {
        document.dispatchEvent(new Event('cookies-accepted'))
      }
    },
    async initializeCookiesState ({ dispatch }, cookies) {
      await dispatch('createCookieSessionState', cookies)
      await dispatch('dispatchDMEventIfCookiesAccepted')
    }
  }
})

// eslint-disable-next-line no-new
window.cookiesModalApp = new Vue({
  el: '#cookies-modal-block',
  store,
  locale,
  config,
  components: {
    CookieModal,
    CookieNotice,
    CookieSettings
  },
  computed: {
    ...mapGetters(['hasAcceptedAdvertisingCookies'])
  },
  mounted () {
    this.initializeCookiesState()
  },
  methods: {
    initializeCookiesState () {
      const instances = {}
      document.addEventListener('cookies-set', (e) => {
        const cookieData = e.detail.cookieData
        if (cookieData) {
          Object.keys(cookieData).map((key) => {
            instances[key] = cookieData[key]
          })
        }
        this.$store.dispatch('initializeCookiesState', instances)
      })
    }
  }
})
